module.exports = __webpack_public_path__ + "static/media/no-voucher-wallet.ac91fd95.svg";